const BAD_REQUEST_CODES = [150003, 150001]
const NOT_FOUND_CODE = 150002

export { NOT_FOUND_CODE, BAD_REQUEST_CODES }
